module.exports = __webpack_public_path__ + "media/newstyle/images/icon-image-upload-d89bd052194f6743049196953d8ef913.svg";